import React, { Component } from "react";
import Images from "../Images";
import { AppConfig } from "../../../helpers";
import SlotGame from "./SlotGame";

export class TopGames extends Component {
  render() {
    const { games, history , topGamesInfoType , title} = this.props;
    console.log("gamesgamesgames",topGamesInfoType);
    return (
      <div className="top-games-wrapper">
        <div className="heading">
          <div>
            <img src={Images.Crown} alt="crown" />
          </div>
          <h2>{title}</h2>
        </div>
        {games &&
          games.map((game) => (
            <div className="single-top-game" key={game.gameId}>
              {console.log("game.slotsGameImages",game.slotsGameImages)}
              <SlotGame
                src={`${AppConfig.icons}${game.platformGameName}/${game.slotsGameImages.filter(ele => ele.imageTypeId ==topGamesInfoType)[0] ? game.slotsGameImages.filter(ele => ele.imageTypeId ==topGamesInfoType)[0].gameImage : game.platformGameName}.webp`}
                history={history}
                gameId={game.gameId}
              />
            </div>
          ))}
        {/* <div className="single-top-game">
          <img src={Images.Joker}/>
        </div>
        <div className="single-top-game">
          <img src={Images.Joker}/>
        </div>
        <div className="single-top-game">
          <img src={Images.Joker}/>
        </div>
        <div className="single-top-game">
          <img src={Images.Joker}/>
        </div>
        <div className="single-top-game">
          <img src={Images.Joker}/>
        </div> */}

        <img />
      </div>
    );
  }
}

export default TopGames;
